import { render } from "./CreateProject.vue?vue&type=template&id=45228e2f&scoped=true"
import script from "./CreateProject.vue?vue&type=script&lang=js"
export * from "./CreateProject.vue?vue&type=script&lang=js"

import "./CreateProject.vue?vue&type=style&index=0&id=45228e2f&lang=less&scoped=true"

import exportComponent from "F:\\workspace\\clientapps\\Advertising-Platform\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45228e2f"]])

export default __exports__